import { ApolloClient, gql, NormalizedCacheObject } from '@copybet/apollo';
import { DTOMutation, DTOQuery } from '@copybet/dto';

const GetRGQuestionQuery = gql`
  query GetRGPopupQuestionsQuery {
    getRGPopupQuestions {
      id
      content
    }
  }
`;

const SetRGAnswersMutation = gql`
  mutation SetRGPopupAnswersMutation($questions: [RGAnswerInput!]!) {
    setRGPopupAnswers(questions: $questions)
  }
`;

const GetIsRGPopupEnabledQuery = gql`
  query GetUserBriefInformation {
    getUserBriefInformation {
      isRGPopupEnabled
    }
  }
`;

export const getIsRGPopupEnabled = async (client: ApolloClient<NormalizedCacheObject>) => {
  try {
    const dataRequest = await client.query<Pick<DTOQuery, 'getUserBriefInformation'>>({
      query: GetIsRGPopupEnabledQuery,
      fetchPolicy: 'no-cache',
    });
    if (dataRequest?.data?.getUserBriefInformation?.isRGPopupEnabled) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error fetching RGPopup state', error);
    return false;
  }
};

export const getRGQuestions = async (client: ApolloClient<NormalizedCacheObject>) => {
  try {
    const data = await client.query<Pick<DTOQuery, 'getRGPopupQuestions'>>({
      query: GetRGQuestionQuery,
    });
    if (data?.data?.getRGPopupQuestions?.length) {
      return data?.data?.getRGPopupQuestions;
    }

    return [];
  } catch (error) {
    console.error('Error fetching RG Questions', error);
    return [];
  }
};

export const setRGAnswers = async (client: ApolloClient<NormalizedCacheObject>, answers: any[]) => {
  try {
    const response = await client.mutate<Pick<DTOMutation, 'setRGPopupAnswers'>>({
      mutation: SetRGAnswersMutation,
      variables: {
        questions: answers,
      },
    });

    if (response?.data?.setRGPopupAnswers) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error during set RG answers', error);
    return false;
  }
};
